export const ORDERDETAILS_REQUEST = "ORDERDETAILS_REQUEST";
export const ORDERDETAILS_SUCCESS = "ORDERDETAILS_SUCCESS";
export const ORDERDETAILS_ERROR = "ORDERDETAILS_ERROR";
export const SETORDERDETAILS = "SETORDERDETAILS_ERROR";
export const ORDERDETAILS_params = {
    key: process.env.VUE_APP_API_KEY,
    connector: 'AppOrderDetailsV1',
    size: 1000,
    filter: []
};